import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
export const TrainerDetailSection = (props) => {
    const styles = StyleSheet.create({
        container: {
            fontSize: 14,
            marginBottom: 14,
            [MediaBreakPointUp.SM]: {
                paddingTop: 20,
            },
        },
    });
    const containerClass = [props.className || '', css(styles.container)].join(' ');
    return (React.createElement("div", { className: containerClass },
        React.createElement(TrainerRow, { key: props.trainer.id, trainer: props.trainer })));
};
const TrainerRow = (props) => {
    const iconSize = 100;
    const iconSizePC = 160;
    const spacing = 20;
    const styles = StyleSheet.create({
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
            justifyContent: 'center',
            alignItems: 'center',
            [MediaBreakPointUp.MD]: {
                flexFlow: 'row nowrap',
                justifyContent: 'space-between',
            },
        },
        icon: {
            marginTop: '10px',
            width: iconSize,
            height: iconSize,
            borderRadius: '50%',
            border: `1px solid ${Colors.Gray}`,
            [MediaBreakPointUp.SM]: {
                width: iconSizePC,
                height: iconSizePC,
                marginRight: 18,
            },
        },
        title: {
            fontSize: 16,
            fontWeight: 'bold',
            textAlign: 'center',
            margin: '8px 0',
            [MediaBreakPointUp.SM]: {
                margin: '18px 0',
                fontSize: 32,
                textAlign: 'left',
            },
        },
        textContainer: {
            [MediaBreakPointUp.MD]: {
                width: `calc(100% - ${iconSize}px - ${spacing}px)`,
            },
        },
        description: {
            color: Colors.Black,
            fontWeight: 300,
            fontSize: 13,
            lineHeight: '1.75',
            [MediaBreakPointUp.MD]: {
                marginBottom: 16,
            },
            [MediaBreakPointUp.XL]: {
                fontSize: 16,
            },
        },
    });
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("img", { className: css(styles.icon), src: props.trainer.thumbnailURL }),
        React.createElement("div", { className: css(styles.textContainer) },
            React.createElement("div", { className: css(styles.title) }, props.trainer.name),
            React.createElement("div", { className: css(styles.description) }, props.trainer.bio))));
};
